import FinalWizardScreen from "./FinalWizardScreen";

export default FinalWizardScreen;



// WEBPACK FOOTER //
// ./src/components/Pricebook/FinalWizardScreen/index.js